import { render } from "./Buttons.vue?vue&type=template&id=0cc30f30&scoped=true"
import script from "./Buttons.vue?vue&type=script&lang=js"
export * from "./Buttons.vue?vue&type=script&lang=js"

import "./Buttons.vue?vue&type=style&index=0&id=0cc30f30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc30f30"]])

export default __exports__